import React, { useMemo, useEffect, Fragment } from 'react';
import moment from 'moment';
import { Grid, Paper, Card, CardHeader, CardContent, Typography, Divider } from '@mui/material';
import { liveTrackinglayoutSelector } from '../../../features/layout/layoutSlice';
import { useSelector } from 'react-redux';
import { useTable } from 'react-table';


const TripFuel = ({ reportData }) => {
    const dimentions = useSelector(liveTrackinglayoutSelector);
    const tableData = useMemo(() => {
        if (reportData.reportRecords && reportData.reportRecords.length > 0) {
            return reportData.reportRecords.map(item => {
                return {
                    vehicle: item.truck_number,
                    startTime: moment(item.loding_time).format("D-MMM YY hh:mm A"),
                    endTime: item.unloding_time ? moment(item.unloding_time).format("D-MMM YY hh:mm A") : 'NA',
                    client_name: item.client_name,
                    driver_name: item.driver_name,
                    fills: item.fills,
                    invoice_number: item.invoice_number,
                    order_id: item.order_id,
                    order: `${item.invoice_number} (${item.order_id})`,
                    thefts: item.thefts,
                    tripStatus: item.tripStatus,
                    truck_number: item.truck_number,
                    distance: `${item.distance}`,
                    consumption: `${item.consumption}`,
                    mileage: `${item.mileage}`,
                    startLoc: item.startLoc,
                    endLoc: item.endLoc,
                    startVol: `${item.startVol}`,
                    endVol: `${item.endVol}`,
                };
            })
        } else {
            return [];
        }
    }, [reportData]);

    /*useEffect(() => {
        //console.log("Trip Report Rows", reportData);
        if (reportData.reportRecords) {
            reportData.reportRecords.forEach(rec => {
                console.log("Record loeded", rec.loaded, 'empty', rec.empty, 'overall', rec.overall, 'stattime', rec.loaded.start_time);
            })
        } else {
            console.log("Report Black");
        }
*/

    const reportItems = () => {
        let items = [];
        if (reportData && reportData.reportRecords && reportData.reportRecords.length > 0) {
            //console.log("Trip fuel recs", reportData.reportRecords);
            reportData.reportRecords.forEach(rec => {
                if (rec.loaded && rec.empty && rec.overall && rec.loaded.start_time) {
                    const thisitem =
                        <Card style={{ width: '100%', marginBottom: '10px' }}>
                            <CardHeader
                                title={
                                    <Grid container spacing={2}>
                                        <Grid item sm={3}>
                                            <Typography gutterBottom variant="body1">
                                                <b>{rec.loaded.truck_number}</b>
                                            </Typography>
                                        </Grid>
                                        <Grid item sm={3}>
                                            <Typography gutterBottom variant="body1">
                                                <b>Client: {rec.loaded.client_name}</b>
                                            </Typography>
                                        </Grid>
                                        <Grid item sm={6}>
                                            <Typography gutterBottom variant="body1">
                                                <b>{rec.loaded.start_time ? moment(rec.loaded.start_time).format("D-MMM 'YY") : ''} to {rec.empty.end_time ? moment(rec.empty.end_time).format("D-MMM 'YY") : ''}</b>
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                }
                                style={{ backgroundColor: 'DodgerBlue', color: 'White' }}
                            >

                            </CardHeader>
                            <CardContent>
                                <Grid container spacing={2}>
                                    <Grid item container sm={12}>
                                        <Grid item sm={3}>
                                            <Typography gutterBottom variant="body1" style={{ color: 'dodgerblue' }}>
                                                <b>Order ID:</b> {rec.loaded.order_id}
                                            </Typography>
                                        </Grid>
                                        <Grid item sm={3}>
                                            <Typography gutterBottom variant="body1" style={{ color: 'dodgerblue' }}>
                                                <b>Invoice No:</b> {rec.loaded.invoice_number}
                                            </Typography>
                                        </Grid>
                                        <Grid item sm={6}>
                                            <Typography gutterBottom variant="body1" style={{ color: 'dodgerblue' }}>
                                                <b>Driver:</b> {rec.loaded.driver_name}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                    <Grid item sm={12}>
                                        <Divider />
                                    </Grid>
                                    <Grid item container sm={12}>
                                        <Grid item sm={6}>
                                            <Typography gutterBottom variant="body1" style={{ color: 'forestgreen' }}>
                                                <b>Leg: Loaded</b>
                                            </Typography>
                                        </Grid>
                                        <Grid item sm={6}>
                                            <Typography gutterBottom variant="body1" style={{ color: 'forestgreen' }}>
                                                <b>Status: </b> {rec.loaded.legStatus}
                                            </Typography>
                                        </Grid>
                                        <Grid item sm={12} container>
                                            <Grid item sm={6}>
                                                <Typography gutterBottom variant="body2">
                                                    <b>Start: </b> {rec.loaded.start_time && moment(rec.loaded.start_time).format("D-MMM 'Y")} {rec.loaded.startLoc && ` from ${rec.loaded.startLoc}`}
                                                </Typography>
                                            </Grid>
                                            <Grid item sm={6}>
                                                <Typography gutterBottom variant="body2">
                                                    <b>Finish: </b> {rec.loaded.end_time ? moment(rec.loaded.end_time).format("D-MMM 'Y") : 'Pending Finish '}{rec.loaded.endLoc && ` at ${rec.loaded.endLoc}`}
                                                </Typography>
                                            </Grid>
                                            <Grid item sm={3}>
                                                <Typography gutterBottom variant="body2">
                                                    <b>Distance: </b> {rec.loaded.distance} Km
                                                </Typography>
                                            </Grid>
                                            <Grid item sm={3}>
                                                <Typography gutterBottom variant="body2">
                                                    <b>Mileage: </b> {rec.loaded.mileage} Km/Liter
                                                </Typography>
                                            </Grid>
                                            <Grid item sm={6}>
                                                <Typography gutterBottom variant="body2">
                                                    <b>Consumption: </b> {rec.loaded.consumption} Liters <i>({rec.loaded.startVol} L - {rec.loaded.endVol} L)</i>
                                                </Typography>
                                            </Grid>

                                            <Grid item sm={3}>
                                                <Typography gutterBottom variant="body2">
                                                    <b>Filling: </b> {rec.loaded.fills} Liter
                                                </Typography>
                                            </Grid>
                                            <Grid item sm={3}>
                                                <Typography gutterBottom variant="body2">
                                                    <b>Removal: </b> {rec.loaded.thefts} Liter
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item sm={12}>
                                        <Divider />
                                    </Grid>
                                    <Grid item sm={12}>
                                        <Grid item sm={12} container>
                                            <Grid item sm={6}>
                                                <Typography gutterBottom variant="body1" style={{ color: 'crimson' }}>
                                                    <b>Leg: Empty</b>
                                                </Typography>
                                            </Grid>
                                            <Grid item sm={6}>
                                                <Typography gutterBottom variant="body1" style={{ color: 'crimson' }}>
                                                    <b>Status: </b> {rec.loaded.legStatus}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                        <Grid item sm={12} container>
                                            <Grid item sm={6}>
                                                <Typography gutterBottom variant="body2">
                                                    <b>Start: </b> {rec.empty.start_time && moment(rec.empty.start_time).format("D-MMM 'Y")} {rec.empty.startLoc && ` from ${rec.empty.startLoc}`}
                                                </Typography>
                                            </Grid>
                                            <Grid item sm={6}>
                                                <Typography gutterBottom variant="body2">
                                                    <b>Finish: </b> {rec.empty.end_time ? moment(rec.empty.end_time).format("D-MMM 'Y") : 'Pending Finish '}{rec.empty.endLoc && ` at ${rec.empty.endLoc}`}
                                                </Typography>
                                            </Grid>
                                            <Grid item sm={3}>
                                                <Typography gutterBottom variant="body2">
                                                    <b>Distance: </b> {rec.empty.distance} Km
                                                </Typography>
                                            </Grid>
                                            <Grid item sm={3}>
                                                <Typography gutterBottom variant="body2">
                                                    <b>Mileage: </b> {rec.empty.mileage} Km/Liter
                                                </Typography>
                                            </Grid>
                                            <Grid item sm={6}>
                                                <Typography gutterBottom variant="body2">
                                                    <b>Consumption: </b> {rec.empty.consumption} Liters <i>({rec.empty.startVol} L - {rec.empty.endVol} L)</i>
                                                </Typography>
                                            </Grid>

                                            <Grid item sm={3}>
                                                <Typography gutterBottom variant="body2">
                                                    <b>Filling: </b> {rec.empty.fills} Liter
                                                </Typography>
                                            </Grid>
                                            <Grid item sm={3}>
                                                <Typography gutterBottom variant="body2">
                                                    <b>Removal: </b> {rec.empty.thefts} Liter
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item sm={12}>
                                        <Divider />
                                    </Grid>
                                    <Grid item sm={12}>
                                        <Grid item sm={12} container>
                                            <Grid item sm={6}>
                                                <Typography gutterBottom variant="body1" style={{ color: 'indigo' }}>
                                                    <b>Trip Overall</b>
                                                </Typography>
                                            </Grid>
                                            <Grid item sm={6}>
                                                <Typography gutterBottom variant="body1" style={{ color: 'indigo' }}>
                                                    <b>Status: </b> {rec.loaded.legStatus}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                        <Grid item sm={12} container>
                                            <Grid item sm={6}>
                                                <Typography gutterBottom variant="body2">
                                                    <b>Start: </b> {rec.overall.start_time && moment(rec.overall.start_time).format("D-MMM 'Y")} {rec.overall.startLoc && ` from ${rec.overall.startLoc}`}
                                                </Typography>
                                            </Grid>
                                            <Grid item sm={6}>
                                                <Typography gutterBottom variant="body2">
                                                    <b>Finish: </b> {rec.overall.end_time ? moment(rec.overall.end_time).format("D-MMM 'Y") : 'Pending Finish '}{rec.overall.endLoc && ` at ${rec.overall.endLoc}`}
                                                </Typography>
                                            </Grid>
                                            <Grid item sm={3}>
                                                <Typography gutterBottom variant="body2">
                                                    <b>Distance: </b> {rec.overall.distance} Km
                                                </Typography>
                                            </Grid>
                                            <Grid item sm={3}>
                                                <Typography gutterBottom variant="body2">
                                                    <b>Mileage: </b> {rec.overall.mileage} Km/Liter
                                                </Typography>
                                            </Grid>
                                            <Grid item sm={6}>
                                                <Typography gutterBottom variant="body2">
                                                    <b>Consumption: </b> {rec.overall.consumption} Liters <i>({rec.overall.startVol} L - {rec.overall.endVol} L)</i>
                                                </Typography>
                                            </Grid>

                                            <Grid item sm={3}>
                                                <Typography gutterBottom variant="body2">
                                                    <b>Filling: </b> {rec.overall.fills} Liter
                                                </Typography>
                                            </Grid>
                                            <Grid item sm={3}>
                                                <Typography gutterBottom variant="body2">
                                                    <b>Removal: </b> {rec.overall.thefts} Liter
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>;

                    items.push(thisitem);
                }

            })
        }
        return items;
    }

    const tableColumns = useMemo(() => {
        return [
            { Header: 'Status', accessor: 'tripStatus' },
            { Header: 'Vehicle', accessor: 'vehicle' },
            { Header: 'Client', accessor: 'client_name' },
            { Header: 'Driver', accessor: 'driver_name' },
            { Header: 'Invoice & Order', accessor: 'order' },

            { Header: 'Start Time', accessor: 'startTime' },
            { Header: 'Start Location', accessor: 'startLoc' },
            { Header: 'End Time', accessor: 'endTime' },
            { Header: 'End Location', accessor: 'endLoc' },

            { Header: 'Distance', accessor: 'distance' },
            { Header: 'Start Level', accessor: 'startVol' },
            { Header: 'Consumption', accessor: 'consumption' },
            { Header: 'Fills', accessor: 'fills' },
            { Header: 'Thefts', accessor: 'thefts' },
            { Header: 'End Level', accessor: 'endVol' },
            { Header: 'Mileage', accessor: 'mileage' },



        ];
    }, []);

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
    } = useTable({ columns: tableColumns, data: tableData });

    if (reportData && reportData.reportRecords && reportData.reportRecords.length > 0) {
        return (
            <Paper style={{ ...dimentions.reportDetailViewBottom, overflow: 'auto' }}>
                <div style={{ margin: '10px' }}>
                    <Grid container spacing={2}>
                        <Grid item container sm={12}>
                            <Card style={{ backgroundColor: 'White', width: '100%' }} variant="outlined">
                                <CardContent>
                                    <Typography variant="h6" style={{ color: 'RoyalBlue' }}><b>Report Summary</b></Typography>
                                    <Divider />
                                    <br />
                                    <Grid container>
                                        <Grid item sm={2}>
                                            <Typography gutterBottom variant="body1" style={{ color: 'Navy' }}>
                                                From
                                            </Typography>
                                        </Grid>
                                        <Grid item sm={10}>
                                            <Typography gutterBottom variant="body1" style={{ color: 'Navy' }}>
                                                {`${moment(reportData.reqBody.timeFrom).format('Do MMM YY hh:mm A')}`}
                                            </Typography>

                                        </Grid>
                                        <Grid item sm={2}>
                                            <Typography gutterBottom variant="body1" style={{ color: 'Navy' }}>
                                                To
                                            </Typography>
                                        </Grid>
                                        <Grid item sm={10}>
                                            <Typography gutterBottom variant="body1" style={{ color: 'Navy' }}>
                                                {`${moment(reportData.reqBody.timeTo).format('Do MMM YY hh:mm A')}`}
                                            </Typography>

                                        </Grid>
                                    </Grid>
                                </CardContent>
                            </Card>
                        </Grid>
                        <Grid item sm={12}>
                            <Grid container>
                                {
                                    reportItems()
                                }
                            </Grid>
                        </Grid>
                    </Grid>
                </div>
            </Paper>
        );
    } else {
        return null;
    }
}


export default TripFuel;